import React from 'react'

const HeartActive = props => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path
      fill={props.fill}
      d="M22 9.396A5.39 5.39 0 0016.615 4 5.379 5.379 0 0012 6.616a5.381 5.381 0 00-10 2.78c0 1.551.654 2.948 1.7 3.933h-.002l7.709 7.392a.766.766 0 001.15.036l7.746-7.428h-.002A5.389 5.389 0 0022 9.396"
      fillRule="evenodd"
    />
  </svg>
)

export default HeartActive
